import React from 'react'
import PropTypes from 'prop-types'
import { LinearProgress } from '@mui/material'
import Colors from 'utils/Colors'

import styles from './styles'

function TextFieldFillBar(props) {
  const { current, min, max } = props

  const classes = styles()
  
  const value = (current / max) * 100
  
  const getColor = () => {
    if (current < min) {
      return Colors.red
    }
    if (current >= min && current < max) {
      return Colors.green
    }
    return Colors.blue
  }

  return (
    <div className={classes.container}>
      <LinearProgress
        variant="determinate"
        value={value}
        color='inherit'
        style={{ color: getColor() }}
      />
      <p>{`${current}/${max}`}</p>
    </div>
  )
}

TextFieldFillBar.propTypes = {
  current: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
}

export default TextFieldFillBar
